import { api } from '@marketplace-web/core-api/core-api-client-util'

import { EducationType } from '../constants/education'
import { ConversationEducationResp } from '../types/conversation-education'

export const markEducationAsRead = (type: EducationType) => api.post('/user/education', { type })

export const fetchConversationEducation = (transactionId?: number, status?: number) =>
  api.get<ConversationEducationResp>(
    `/users/educations?transaction_id=${transactionId}&status=${status}`,
  )
